import { getApiClient } from '../../client';
import { handleApiError } from '../../utils/handleApiError';
import type { ServiceResponse, PortfolioResponse } from '@dopomogai/types';

const PORTFOLIO_PREFIX = '/my-portfolio';

export const portfolioService = {
  /**
   * Fetches the authenticated user's complete investment portfolio.
   */
  getMyPortfolio: (): ServiceResponse<PortfolioResponse> => {
    return getApiClient().get<PortfolioResponse>(`${PORTFOLIO_PREFIX}`)
      .then(res => res.data)
      .catch(err => handleApiError(err, 'fetching user portfolio'));
  },
};
